export default __webpack_public_path__ + "static/media/flex-insurance-color.807df01b.svg";